import { put } from "redux-saga/effects";

import { writeToLocalStorage } from "common/utilities/localStorage";
import { setThemeSuccess } from "domains/theme/actions";
import type { SetThemeAction } from "domains/theme/actionTypes";

export function* setThemeSaga({ theme }: SetThemeAction) {
  try {
    writeToLocalStorage("theme", theme);
    yield put(setThemeSuccess(theme));
  } catch {
    yield put(setThemeSuccess("light"));
  }
}
